import React from 'react';
import i18next from 'i18next';
import UtilsService from './../../services/utils/utils.service';
import Currency from './../shared/currency';

export const BalanceTotal = ({ ...props }) => {
    if (!props.totals || !props.totals.length)
        return null;

    return (
        <div className={`${props.className || ''} d-inline-block ml-2 ${props.totals.length > 1 ? 'align-top' : ''}`}>
            {
                props.label ?
                    <label className="mb-0 text-bold">{i18next.t(props.label)}: </label> :
                    null
            }
            {
                props.totals.map((t, i) => {
                    let colorClass = (t.amount > 0) ? 'text-success' : (t.amount < 0) ? 'text-danger' : '';
                    return (
                        <div className="d-flex align-items-baseline">
                            {t.title ? <strong className="d-inline-block text-right" style={{ width: '150px' }}>
                                {t.title}
                            </strong> : null}
                            <div key={i} className={`text-bold lh-1 text-right ${colorClass} ml-2 d-flex align-items-end`}>
                                <Currency amount={t.amount} symbol={UtilsService.translateCurrencySymbol(t.symbol)} />
                            </div>
                        </div>
                    )
                })
            }
        </div>
    );
}